module.exports = __webpack_public_path__ + "img/custom_a_banner.ea27826.webp";